import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { useContent } from "@/context/ContentContext";

export const Footer = () => {
  const { content } = useContent();
  const c = content?.contact || {};

  return (
    <footer className="bg-[#1F2937] text-gray-300" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-20 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-1">
          <div className="font-display font-extrabold text-white text-xl">AA+PLUS</div>
          <div className="font-display font-semibold tracking-[0.2em] text-[11px] text-[#FF5A00] mb-4">MILJØSANERING</div>
          <p className="text-sm text-gray-400 leading-relaxed">
            {c.address}<br />
            {c.postal_city}<br />
            CVR: {c.cvr}
          </p>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Sider</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-forside">Forside</Link></li>
            <li><Link to="/ydelser" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-ydelser">Ydelser</Link></li>
            <li><Link to="/om-os" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-om-os">Om os</Link></li>
            <li><Link to="/samarbejde" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-samarbejde">Samarbejde</Link></li>
            <li><Link to="/referencer" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-referencer">Referencer</Link></li>
            <li><Link to="/kontakt" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-kontakt">Kontakt</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Juridisk</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/privatlivspolitik" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-privatliv">Privatlivspolitik</Link></li>
            <li><Link to="/cookiepolitik" className="hover:text-[#FF5A00] transition-colors" data-testid="footer-cookie">Cookiepolitik</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Kontakt</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Phone size={16} className="text-[#FF5A00] mt-0.5 shrink-0" />
              <a href={`tel:${(c.phone || "").replace(/\s/g, "")}`} className="hover:text-[#FF5A00] transition-colors" data-testid="footer-phone">{c.phone}</a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={16} className="text-[#FF5A00] mt-0.5 shrink-0" />
              <a href={`mailto:${c.email}`} className="hover:text-[#FF5A00] transition-colors break-all" data-testid="footer-email">{c.email}</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={16} className="text-[#FF5A00] mt-0.5 shrink-0" />
              <span>{c.address}, {c.postal_city}</span>
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-gray-500">
          <span>© {new Date().getFullYear()} AA+PLUS MILJØSANERING · CVR {c.cvr}</span>
          <Link to="/admin" className="hover:text-gray-300 transition-colors" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
